<template>
  <v-snackbar
    v-model="showSnackbarLocal"
    :color="type"
    :class="$style['base-snackbar']"
    multi-line
    bottom
    :timeout="timeout"
  >
    <p>{{ message }}</p>

    <v-btn color="black" text small @click="showSnackbarLocal = false">{{
      $t('general.close')
    }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    timeout: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: 0,
    },
    message: {
      type: String,
      default: '',
    },
    showSnackbar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSnackbarLocal: this.showSnackbar,
    }
  },
  computed: {
    type() {
      return this.status === 200 ? 'success' : 'error'
    },
  },
  watch: {
    message() {
      if (this.message.length === 0) {
        this.showSnackbarLocal = false
      }

      if (!this.showSnackbarLocal && this.message.length > 0) {
        this.showSnackbarLocal = true
      }
    },
    showSnackbar() {
      this.showSnackbarLocal = this.showSnackbar
    },
    showSnackbarLocal() {
      if (this.showSnackbarLocal !== this.showSnackbar) {
        this.$emit('input', this.showSnackbarLocal)
      }
    },
  },
}
</script>

<style lang="scss" module>
.list-item {
  word-break: break-all;
}

.base-snackbar :global(.success) {
  color: var(--black);
}
</style>
